import { checkUndefinedNullOrEmpty } from '../../_tools/Tools';
import { type SelectDataObject } from '../../_tools/inputfields/Select';
import { EffizienzClass } from './types';

export const effizienzSteps: (wltp: boolean) => SelectDataObject<{ color: string; nested: number; tSend?: string }>[] = (wltp) =>
    [
        { i: EffizienzClass.N_A, t: 'N/A', tSend: 'None', color: '#232323', nested: 1, effizienz: { wltp } },
        !wltp ? { i: EffizienzClass.AAAA, t: 'A+++', color: '#00A650', nested: 1, effizienz: { wltp } } : undefined,
        !wltp ? { i: EffizienzClass.AAA, t: 'A++', color: '#00A650', nested: 1, effizienz: { wltp } } : undefined,
        !wltp ? { i: EffizienzClass.AA, t: 'A+', color: '#00A650', nested: 1, effizienz: { wltp } } : undefined,
        { i: EffizienzClass.A, t: 'A', color: '#00A650', nested: 1, effizienz: { wltp } },
        { i: EffizienzClass.B, t: 'B', color: '#4FBB48', nested: 2, effizienz: { wltp } },
        { i: EffizienzClass.C, t: 'C', color: '#BED730', nested: 3, effizienz: { wltp } },
        { i: EffizienzClass.D, t: 'D', color: '#FFF200', nested: 4, effizienz: { wltp } },
        { i: EffizienzClass.E, t: 'E', color: '#FCB217', nested: 5, effizienz: { wltp } },
        { i: EffizienzClass.F, t: 'F', color: '#F36F21', nested: 6, effizienz: { wltp } },
        { i: EffizienzClass.G, t: 'G', color: '#ED1C24', nested: 7, effizienz: { wltp } },
    ]?.filter((e) => !checkUndefinedNullOrEmpty(e));
